<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  viewBox="0 0 10 10"
  fill="none"
>
  <path d="M2.96917 9.40167L0 10L0.599167 7.03125L2.96917 9.40167ZM1.18833 6.44167L3.55833 8.81208L10 2.37042L7.62958 0L1.18833 6.44167Z" fill="#5E8895"/>
</svg>
